import { type I18N } from '.';

export const sv = {
  loginWith: 'Logga in med',
  approveWith: 'Godkänn med',
  signWith: 'Signera med',
  confirmWith: 'Bekräfta med',
  acceptWith: 'Acceptera med',
  sameDevice: 'På denna enhet',
  anotherDevice: 'Med ditt personnummer',
  anotherDeviceQR: 'På annan enhet',
  mitidBusiness: 'MitID Erhverv',
  finnishMobileID: 'Finskt Mobilcertifikat',
  finnishBankID: 'Finskt Bank ID',
  swedishBankID: 'Svenskt BankID',
  norwegianBankID: 'Norska BankID',
  biometrics: 'Biometri',
  openAndScan: 'Öppna BankID-appen på din mobila enhet och skanna QR-koden.',
  thisIsTheQR: 'Detta är en QR-kod från BankID. Du kan klicka på den för att visa den i fullskärm.',
  completingLogin: 'Slutför din inloggning.',
} satisfies I18N;
